type IProposalData = {
  program_includes?: string
  payment_method?: string
  important?: string
  the_advertised_price_does_not_include?: string
  notes?: string
  institution?: { fantasy_name: string }
  destination?: string
  group?: string
  date?: string
  departure_time?: string
  expected_arrival_at_the_unit?: string
  pick_up_and_drop_off_location?: string
  number_of_people?: string
  proposal_price?: string
  installments?: { value: string }[]
}

const buildParagraphs = (text: string) =>
  text
    .split('\n')
    .map((item) => `<p>${item}</p>`)
    .join('')

export const createDefaultDescriptionProposalData = ({
  program_includes,
  payment_method,
  important,
  the_advertised_price_does_not_include,
  notes,
  institution,
  destination,
  group,
  date,
  departure_time,
  expected_arrival_at_the_unit,
  pick_up_and_drop_off_location,
  number_of_people,
  proposal_price,
  installments,
}: IProposalData) => {
  let result = ``

  if (institution?.fantasy_name) {
    result += `<b>Instituição:</b> ${institution?.fantasy_name}<br>`
  }
  if (destination) {
    result += `<b>Destino:</b> ${destination}<br>`
  }
  if (group) {
    result += `<b>Turma:</b> ${group}<br>`
  }
  if (date) {
    result += `<b>Data:</b> ${date}<br>`
  }
  if (departure_time) {
    result += `<b>Hora saída e retorno:</b> ${departure_time}<br>`
  }
  if (expected_arrival_at_the_unit) {
    result += `<b>Previsão de chegada à unidade:</b> ${expected_arrival_at_the_unit}<br>`
  }
  if (pick_up_and_drop_off_location) {
    result += `<b>Local de embarque e desembarque:</b> ${pick_up_and_drop_off_location}<br>`
  }

  if (
    institution ||
    destination ||
    group ||
    date ||
    departure_time ||
    expected_arrival_at_the_unit ||
    pick_up_and_drop_off_location
  ) {
    result += `<br>`
  }

  if (program_includes) {
    result += `<b>O programa inclui</b>`
    result += buildParagraphs(program_includes)
  }

  let price = proposal_price

  if (!proposal_price || proposal_price === '0,00') {
    const valueInstallment = installments?.[0]?.value
    price = valueInstallment
  }

  result += `<br><b>Valor por aluno: R$ ${price}</b>`
  result += buildParagraphs(
    `Grupo mínimo de ${number_of_people} alunos pagantes`,
  )

  if (payment_method) {
    result += `<br><b>Condições de pagamento</b>`
    result += buildParagraphs(payment_method)
  }
  if (important) {
    result += `<br><b>Importante</b>`
    result += buildParagraphs(important)
  }
  if (the_advertised_price_does_not_include) {
    result += `<br><b>O preço anunciado não inclui</b>`
    result += buildParagraphs(the_advertised_price_does_not_include)
  }
  if (notes) {
    result += `<br><b>Observações</b>`
    result += buildParagraphs(notes)
  }

  return result
}
